import React, { useRef, useEffect } from 'react';

import _ from 'lodash';
import cx from 'classnames';

import { ExternalFormWidgetContext } from '..';

import styles from '../style.module.scss';

export const ExternalForm = ({ form, uid, widget, breakpoint }) => {
  const context = React.useContext(ExternalFormWidgetContext);
  const url = _.get(form.configuration, "url", null);

  const contextRef = useRef(context);

  const width = _.get(widget, `properties.${breakpoint}.layout.width`);
  const height = _.get(widget, `properties.${breakpoint}.layout.height`);

  useEffect(() => {
    contextRef.current = context;
  }, [context]);

  useEffect(() => {
    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleFormSubmit, false);

  }, [])

  const handleFormSubmit = (e) => {
    const currentContext = contextRef.current;

    //Removing message event listner
    if (currentContext && e.data.type === 'EXTERNAL_FORM_SUBMISSION') {
      var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
      var deEventer = window[detachEventMethod];
      var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

      var email = e.data.payload.email;
      var firstName = e.data.payload.firstName;
      var lastName = e.data.payload.lastName;
      var company = e.data.payload.company;
      var title = e.data.payload.title;
      var workPhone = e.data.payload.workPhone;

      var contactRequest = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        company: company,
        title: title,
        workPhone: workPhone,
        formSource: 'external',
      }

      currentContext.onFormSubmit(contactRequest, currentContext.parent);

      deEventer(messageEvent, handleFormSubmit, false);

      return;
    }
  }

  if(!url) {
    return null;
  }

  return (
    <div className={cx(styles.externalForm)}>
      <iframe className={styles.externalFormIframe} src={url} width={width} height={height} />
    </div>
  )
}
